import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yi-main-side',
  template: require('./main-side.component.html'),
  styles: [require('./main-side.component.scss')]
})
export class MainSideComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
